(() => {
  'use strict';
  const root = () => window.Shopify?.routes?.root || '/';
  function initFilters(scope = document) {
    scope.querySelectorAll('[data-lvn-products]').forEach(section => {
      if (section.dataset.lvnReady) return;
      section.dataset.lvnReady = 'true';
      applyFilter(section, 'all');
    });
  }
  function applyFilter(section, category) {
    let count = 0;
    const limit = Number(section.dataset.limit) || 4;
    section.querySelectorAll('[data-lvn-card]').forEach(card => {
      const show = (category === 'all' || card.dataset.category === category) && count < limit;
      card.hidden = !show;
      if (show) count++;
    });
    section.querySelectorAll('[data-lvn-filter]').forEach(b => {
      const on = b.dataset.lvnFilter === category;
      b.setAttribute('aria-pressed', String(on));
      b.classList.toggle('lvn-active', on);
    });
  }
  function closeDialog(dialog) {
    dialog.close();
    document.body.style.overflow = '';
    if(dialog.matches('.lvn-menu-dialog')) document.querySelectorAll('[data-lvn-menu-toggle]').forEach(b=>b.setAttribute('aria-expanded','false'));
  }
  // Preserve the original cart drawer for retained product templates, but use the
  // canonical cart page from this header to avoid competing app click handlers.
  document.addEventListener('click',event=>{
    const bag=event.target.closest('.lvn-bag');
    if(bag){event.preventDefault();event.stopImmediatePropagation();window.location.assign(bag.href);}
  },true);
  document.addEventListener('DOMContentLoaded',()=>{
    const bag=document.querySelector('.lvn-bag');
    if(bag){bag.removeAttribute('role');bag.removeAttribute('aria-haspopup');}
  });
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-lvn-open]');
    if (open) {
      const dialog = document.getElementById(open.dataset.lvnOpen);
      if (dialog) {
        event.preventDefault();
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        dialog.querySelector('[data-lvn-search-input]')?.focus();
      }
    }
    const close = event.target.closest('[data-lvn-close]');
    if (close) closeDialog(close.closest('dialog'));
    if (event.target.matches('dialog.lvn-dialog,dialog.lvn-menu-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(event.target);
    }
    const tab = event.target.closest('[data-lvn-filter]');
    if (tab) applyFilter(tab.closest('[data-lvn-products]'), tab.dataset.lvnFilter);
    const toggle = event.target.closest('[data-lvn-menu-toggle]');
    if (toggle) {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (menu) {
        menu.querySelector('.lvn-mobile-root').hidden=false;
        menu.querySelectorAll('.lvn-mobile-panel').forEach(p=>p.hidden=true);
        menu.showModal();document.body.style.overflow='hidden';toggle.setAttribute('aria-expanded','true');
      }
    }
    const panelButton=event.target.closest('[data-lvn-panel-open]');
    if(panelButton){
      const menu=panelButton.closest('dialog'),panel=document.getElementById(panelButton.dataset.lvnPanelOpen);
      if(panel){menu.querySelector('.lvn-mobile-root').hidden=true;panel.hidden=false;panel.querySelector('[data-lvn-panel-back]').focus();}
    }
    const back=event.target.closest('[data-lvn-panel-back]');
    if(back){const panel=back.closest('.lvn-mobile-panel'),menu=back.closest('dialog');panel.hidden=true;menu.querySelector('.lvn-mobile-root').hidden=false;menu.querySelector('[data-lvn-panel-open="'+panel.id+'"]')?.focus();}
    if(!event.target.closest('[data-lvn-desktop-menu]'))document.querySelectorAll('[data-lvn-desktop-menu][open]').forEach(d=>d.open=false);
  });
  document.addEventListener('cancel', event => {
    if (event.target.matches('dialog.lvn-dialog,dialog.lvn-menu-dialog')) {
      event.preventDefault();
      closeDialog(event.target);
      document.querySelectorAll('[data-lvn-menu-toggle]').forEach(b=>b.setAttribute('aria-expanded','false'));
    }
  }, true);
  document.addEventListener('pointerover',event=>{
    if(!matchMedia('(hover:hover) and (min-width:1201px)').matches)return;
    const menu=event.target.closest('[data-lvn-desktop-menu]');
    if(menu){document.querySelectorAll('[data-lvn-desktop-menu]').forEach(d=>d.open=d===menu);}
    else if(!event.target.closest('.lvn-header'))document.querySelectorAll('[data-lvn-desktop-menu][open]').forEach(d=>d.open=false);
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('[data-lvn-desktop-menu][open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-lvn-variant]');
    if (!select) return;
    const option = select.selectedOptions[0], dialog = select.closest('dialog');
    if (!option || !dialog) return;
    dialog.querySelector('[data-lvn-price]').textContent = option.dataset.price;
    const image = dialog.querySelector('.lvn-variant-image');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    const add = dialog.querySelector('[data-lvn-add]');
    add.disabled = option.dataset.available !== 'true';
    add.textContent = add.disabled ? add.dataset.soldOut : add.dataset.label;
    const details = dialog.querySelector('[data-lvn-product-url]');
    details.href = details.dataset.lvnProductUrl + '?variant=' + select.value;
    dialog.querySelector('[data-lvn-status]').textContent = '';
    dialog.querySelector('[data-lvn-cart-link]').hidden = true;
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.lvn-product-form')) return;
    event.preventDefault();
    const button = form.querySelector('[data-lvn-add]'), status = form.querySelector('[data-lvn-status]');
    if (button.disabled) return;
    button.disabled = true; button.setAttribute('aria-busy', 'true'); status.textContent = '';
    let added = false;
    try {
      const payload=new FormData(form);
      const response = await fetch(root() + 'cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body:payload });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || status.dataset.error);
      added = true;
      status.textContent = status.dataset.success;
      form.querySelector('[data-lvn-cart-link]').hidden = false;
      document.dispatchEvent(new CustomEvent('cart:add', {detail:{id:Number(form.elements.id.value),qty:1}}));
      const cartResponse = await fetch(root() + 'cart.js', {headers:{'Accept':'application/json'}});
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-lvn-cart-count]').forEach(el => el.textContent = cart.item_count);
      }
    } catch (error) {
      if (!added) status.textContent = error.message || status.dataset.error;
    } finally {
      button.disabled = form.querySelector('[data-lvn-variant]').selectedOptions[0].dataset.available !== 'true';
      button.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('shopify:section:load', event => initFilters(event.target));
  const sizeCache=new Map();
  async function initSizes(scope=document){
    for(const slot of scope.querySelectorAll('[data-lvn-size-source]')){
      if(slot.dataset.loaded)continue;slot.dataset.loaded='true';const url=slot.dataset.lvnSizeSource;
      if(!sizeCache.has(url))sizeCache.set(url,fetch(url).then(r=>{if(!r.ok)throw new Error('Size data unavailable');return r.text();}).then(html=>new DOMParser().parseFromString(html,'text/html').querySelector('[data-lvn-size-results]')?.innerHTML||''));
      try{const html=await sizeCache.get(url);slot.innerHTML=html;slot.classList.add('lvn-size-results');if(!slot.querySelector('a'))slot.closest('.lvn-mega-sizes').hidden=true;}catch{slot.closest('.lvn-mega-sizes').hidden=true;}
    }
  }
  document.addEventListener('shopify:section:load',event=>initSizes(event.target));
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-lvn-card]');
    if (card) card.hidden = false;
  });
  initFilters();
  initSizes();
})();
